export default {"src":"/_next/static/media/cl.e0b12a09.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};